module.exports = __webpack_public_path__ + "static/media/MbBanescoLogo.930ff492.svg";